'use client';

import * as React from "react"

import { useSystemAnnouncement } from "@/stores/appStore";
import { usePathname } from "next/navigation";
import { VolumeIcon } from "@/components/fun-ui/icons";
import ReactMarkdown from "react-markdown";
import { externalMarkdownLink } from "@/components/md-components";
import { useEffect } from "react";

export function SystemAnnouncement() {
  const pathname = usePathname();
  const {
    content,
    getContent,
  } = useSystemAnnouncement();

  useEffect(() => {
    (async () => {
      await getContent(pathname);
    })();
  }, [getContent, pathname]);

  if (!content) {
    return <></>;
  }


  return (
    <div className="flex flex-row h-10 bg-[#F8E9E2] items-center justify-center gap-2 text-[#FF6700]">
      <VolumeIcon />
      <ReactMarkdown components={externalMarkdownLink}>{content}</ReactMarkdown>
    </div>
  )
}
